<template>
  <div class="content">
    <div class="bg">
      <div class="block">
        <div class="item">
          <span class="star">*</span>
          <p class="topic">
            <input class="enter" v-model="topic" type="text" :placeholder="`请输入${$_syscfg.interview}主题`" maxlength="60">
            <span class="count">{{`${topic.length}/60`}}</span>
          </p>
        </div>
        <div class="item">
          <span class="star">*</span>
          <div class="autoSelector">
            <div :class="{depart: true, on: showDepart}" @click="toggleDepart()">
              <span :class="{department: true, filled: selectedDep.title}">{{selectedDep.title || '请选择部门'}}</span>
              <img class="icon" :src="showDepart ? icons.up: icons.down" alt="arrow">
            </div>
            <div class="selections" v-if="showDepart">
              <p class="opt" v-for="(d, i) in deps" :key="i" @click="selectdep(d)">
                <span>{{d.title}}</span>
                <img v-if="d.id === selectedDep.id" src="@assets/img/interview/select.svg" alt="select">
              </p>
            </div>
          </div>
        </div>
        <div class="item">
          <span class="star">*</span>
          <date-picker :notBefore="timeBefore" v-model="datePicker" range placeholder="    开始时间    ～    结束时间" calendar-icon="none" :editable="false" :clearable="true" :shortcuts="false" :type="'datetime'" :format="'YYYY-MM-DD HH:mm'" confirm></date-picker>
        </div>
        <div class="item">
          <span class="star">*</span>
          <div class="locate">
            <!-- <span class="location">{{locate || '请选择/输入地址'}}</span> -->
            <input type="text" v-model="locate" placeholder="请选择/输入地址">
            <img class="icon" src="@assets/img/interview/locate.svg" alt="locate" @click="openLocation()">
          </div>
        </div>
      </div>
      <div class="block">
        <p class="title">
          {{`${$_syscfg.interview}需求`}}
        </p>
        <div class="item">
          <span class="star">*</span>
          <div class="autoSelector">
            <div :class="{reporter: true, on: focusInputing}">
              <span v-show="s.selected" class="selectd" v-for="(s, i) in reporters" :key="i">
                <span>{{s.name}}</span>
                <img class="close" src="@assets/img/interview/del.svg" alt="close" @click="unSelectReporter(s)">
              </span>
              <input class="enter" type="text" placeholder="请选择记者" @focus="focusInput()" @blur="blurInput()" v-model="reporter" @keyup="searchReporters()">
              <img src="@assets/img/interview/reporter.svg" alt="reporter">
            </div>
            <div class="selections" v-if="focusInputing">
              <p class="opt" v-for="(r, d) in reporters" :key="d" @mousedown="selectReporter(r)" v-show="!r.hide">
                <span>{{r.name}}</span>
                <img v-if="r.selected" src="@assets/img/interview/select.svg" alt="select">
              </p>
            </div>
          </div>
        </div>
        <div class="item" v-for="(b, i) in bases" :key="i">
          <p class="category">
            {{b.rc_name}}
          </p>
          <counter v-on:getValue="getBaseCounter" :name="b.rc_name" :now="0" :max="b.max_num - 0" />
        </div>
        <div class="remark">
          <textarea v-model="remark" class="enter" :placeholder="`${$_syscfg.interview}备注`" maxlength="200"></textarea>
          <p class="count">{{`${remark.length}/200`}}</p>
        </div>
      </div>
      <div class="block">
        <p class="title">
          拓展类设备
        </p>
        <div class="equipContainer">
          <div class="equipment" v-for="(e, i) in expands" :key="i">
            <p class="category">
              {{e.rc_name}}
            </p>
            <counter v-on:getValue="getSubCounter" :name="e.rc_name" :now="0" :max="e.max_num - 0" />
          </div>
        </div>
      </div>
      <!-- <div class="block" v-if="enableAssociate">
        <p class="title">
          {{`关联${$_syscfg.topic}`}}
        </p>
        <div class="linkTopic">
          <p class="linkBtn" @click="openLink()">
            <img src="@assets/img/interview/link.svg" alt="link">
            <span>{{`关联${$_syscfg.topic}`}}</span>
          </p>
          <span :class="{linkMsg: true, linked: associate.title}">{{associate.title || `仅可关联1条${$_syscfg.topic}`}}</span>
        </div>
      </div> -->
    </div>
    <div class="footLine" :style="{width: `calc(100vw - ${footLineGap}px)`}">
      <span :class="{'btn': true, 'disabled': posting}" @click="addNew()">提交</span>
      <span class="btn gray" @click="goBack()">取消</span>

      <div v-if="has_topic_power && topicExist" :class="{autoPost: true, autoPostOn: autoPost.on}" @click="switchAutoPost()">
        <img :src="autoPost.on?autoPost.icons.on:autoPost.icons.off" alt="checker">
        <span>{{`同时生成一条选题`}}</span>
      </div>
    </div>
    <withTopic :from="1" ref="withTopic" @getTopic="getLink" />
    <location ref="location" @getLocation="getLocate" />
    <successTip ref="successTip" />
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import counter from '@components/counter'
import withTopic from '@components/withTopic'
import location from '@components/location'
import common from '@common/common'
import {apis} from '@common/config'
import dc from '@common/dc'
import successTip from '@components/successTip'

export default {
  name: 'newInterview',
  components: {
    DatePicker, counter, withTopic, location, successTip
  },
  data() {
    return {
      has_topic_power: false,
      topicExist: false,
      autoPost: {
        icons: {
          on: require("@assets/img/common/autoCheckerOn.svg"),
          off: require("@assets/img/common/autoChecker.svg")
        },
        on: false
      },
      icons: {
        up: require('@assets/img/interview/up.svg'),
        down: require('@assets/img/interview/down.svg')
      },
      topic: '',
      showDepart: false,
      datePicker: '',
      locate: '',
      reporter: '',
      reporters: [],
      deps: [],
      selectedDep: {},
      focusInputing: false,
      remark: '',
      bases: [],
      expands: [],
      associate: {},
      timeBefore: '', // 当前日期开始时间，用于时间插件禁选功能
      posting: false,
      footLineGap: 230,
      enableAssociate: false
    }
  },
  watch: {
    datePicker: function(n, o) {
      // this.timeBefore = common.stampToTime(n[0]) || this.getTomarrowTime()[0]
      this.timeBefore = this.getTodayStart()
    }
  },
  methods: {
    async switchAutoPost() {
      if (!this.autoPost.on) {
        this.$toast('当前采访通过后，将自动生成一条选题，可前往对应模块查看！')
      }

      this.$set(this.autoPost, "on", !this.autoPost.on);
    },
    goBack() {
      // window.history.go(-1)

      window.close()
    },
    searchReporters() {
      // 筛选记者
      this.reporters.forEach((i) => {
        this.$set(i, 'hide', true)
      })

      this.reporters.forEach((i) => {
        if (i.name.indexOf(this.reporter) > -1) {
          this.$set(i, 'hide', false)
        }
      })
    },
    toggleDepart(){
      // 切换部门
      this.showDepart = !this.showDepart
    },
    getBaseCounter(d) {
      // 接收基础类数量
      this.matchResources(d, this.bases)
    },
    getSubCounter(d) {
      // 接收拓展类数量
      this.matchResources(d, this.expands)
    },
    matchResources(d, l) {
      // 将接收到的资源数量数据同步到数据模型
      l.forEach((i) => {
        if (d.name === i.rc_name) {
          i.num = d.value
        }
      })
    },
    selectReporter(r) {
      // 选择记者
      this.$set(r, 'selected', true)
      this.reporter = ''
      this.searchReporters()
      // this.focusInputing = false
    },
    selectdep(d) {
      // 选择部门
      this.selectedDep = d
      this.reporters = d.reporters
      this.showDepart = false
    },
    unSelectReporter(r) {
      // 反选记者
      this.$set(r, 'selected', false)
    },
    blurInput() {
      // 记者输入框失去焦点
      this.focusInputing = false
    },
    focusInput() {
      // 记者输入框获取焦点
      this.focusInputing = true
    },
    getLink(t) {
      // 接收关联选题
      this.associate = t

      setTimeout(() => {
        dc.delTpc()
      }, 500)
    },
    fromTopic() {
      // 接收选题数据
      // const t = this.$route.params.topic
      const t = dc.getTpc()

      if (t) {
        this.getLink(t)
      }
    },
    getLocate(l) {
      // 接收所选地理位置
      this.locate = l
    },
    closePops() {
      // 关闭记者和部门菜单
      this.focusInputing = false
      this.showDepart = false
    },
    openLink() {
      // 打开关联选题弹窗
      this.closePops()
      this.$refs.withTopic.open()
    },
    openLocation() {
      // 打开地理位置弹窗
      this.closePops()
      this.$refs.location.open()
    },
    getData() {
      // 获取配置数据
      common.myFetch(apis.Itv_interview_new_data, {})
      .then((data) => {
        this.has_topic_power = data.has_topic_power
        this.topicExist = data.topicExist
        this.deps = data.departs
        this.expands = data.sub_class
        this.bases = data.bass_class
        // this.reporters = this.getdefaultReporter()
        this.getDefaultDepartmentAndReporter()
        this.enableAssociate = !!data.topicExist
      })
    },
    getDefaultDepartmentAndReporter() {
      // 默认选择部门和其中的记者
      this.deps.forEach((i) => {
        if (i.selected) {
          this.selectdep(i)
        }
      })
    },
    getdefaultReporter() {
      // 默认选中记者列
      let reporters = []
      this.deps.forEach(i => {
        i.reporters.forEach(j => {
          if (j.selected) {
            reporters = i.reporters
          }
        })
      })

      return reporters
    },
    formReporter(d) {
      // 将记者数据组装为接口格式
      const r = []
      d.forEach(i => {
        if (i.selected) {
          r.push(`${i.id}#${i.name}`)
        }
      })

      return r.join(',')
    },
    formClass(d) {
      // 将资源（基础、拓展）数据组装为接口格式
      const r = []
      d.forEach(i => {
        r.push(`${i.rc_id}:${i.rc_name}:${i.num || 0}`)
      })

      return r.join(';')
    },
    addNew() {
      // 提交新增数据
      if (this.posting) return

      const title = this.topic
      const depart_id = this.selectedDep.id
      const depart_name = this.selectedDep.title
      const start = this.datePicker[0] ? common.stampToTime(this.datePicker[0]) : ''
      const end = this.datePicker[1] ? common.stampToTime(this.datePicker[1]) : ''
      const address = this.locate
      const reporters = this.formReporter(this.reporters)
      const remark = this.remark
      const base_class = this.formClass(this.bases)
      const sub_class = this.formClass(this.expands)
      const st_id = this.associate.id
      const required = common.allRequired([title, depart_id, start, end, address, reporters])

      if (!required) {
        this.$toast('必填项不可为空')
        return
      }

      const info = {
        title: title,
        depart_id: depart_id,
        depart_name: depart_name,
        start: start,
        end: end,
        address: address,
        reporters: reporters,
        remark: remark,
        base_class: base_class,
        sub_class: sub_class,
        st_id: st_id,
        is_output_topic: this.autoPost.on ? 1 : 0
      }
      
      this.posting = true
      common.myFetch(apis.Itv_interview_new, info)
      .then((data) => {
        if (data) {
          const info = {
            msg: data,
            tip: '页面即将关闭'
          }

          this.$refs.successTip.open(info)
        } else {
          this.posting = false
        }
      })
    },
    getTodayStart() {
      const today = new Date()
      const year = today.getFullYear()
      const month = today.getMonth() + 1
      const day = today.getDate()
      const startSec = new Date(`${year}-${month}-${day} 00:00:00`)

      return startSec
    },
    getToday() {
      // 获取当日时间戳
      const today = new Date()
      const year = today.getFullYear()
      const month = today.getMonth() + 1
      const day = today.getDate()
      const startSec = new Date(`${year}-${month}-${day} 09:00:00`)
      const endSec = new Date(`${year}-${month}-${day} 17:00:00`)

      return [startSec, endSec]
    },
    getTomarrowTime() {
      // 获取明天时间戳
      const today = +new Date()
      const tomarrow = new Date(today+1000*60*60*24)
      const year = tomarrow.getFullYear()
      const month = tomarrow.getMonth() + 1
      const day = tomarrow.getDate()
      const startSec = new Date(`${year}-${month}-${day} 09:00:00`)
      const endSec = new Date(`${year}-${month}-${day} 12:00:00`)

      return [startSec, endSec]
    },
    initDate() {
      // 默认选中当日时间
      const today = this.getTomarrowTime()

      this.datePicker = today
    }
  },
  mounted() {
    this.getData()
    this.fromTopic()
    this.initDate()
  }
}
</script>

<style lang="less" src="@assets/css/interview/editInterview.less" scoped></style>

<style lang="less" scoped>
.autoPost {
  position: absolute;
  top: 50%;
  right: 40px;
  transform: translateY(-50%);
  height: 40px;
  border-radius: 100px;
  border: 1px solid #dcdcdc;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #41B48C;
  cursor: pointer;
  box-sizing: border-box;
  padding: 0 20px;

  img {
    margin-right: 6px;
  }
}

.autoPostOn {
  border-color: #41B48C;
}
</style>